/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

import { YospaceAdsSession } from './YospaceAdsSession';
import { YospaceSession } from './internal/YospaceSession';
import { Logger } from '@quickplay/foundation';

export class YospaceAdsSessionFactory {
  static createYospaceAdsSession(yospaceSDK: any, logger?: Logger): YospaceAdsSession {
    return new YospaceSession(yospaceSDK, logger);
  }
}
